import { PERMISSIONS as P } from "@lib/permissions/permissions.generated";

export const TARIF_PERMISSIONS = {
  GRILLES_VIEW: P.VENTES.TARIFS.VIEW,
  GRILLES_CREATE: P.VENTES.TARIFS.CREATE,
  GRILLES_EDIT: P.VENTES.TARIFS.EDIT,
  GRILLES_DELETE: P.VENTES.TARIFS.DELETE,
  PROMOTIONS_VIEW: P.VENTES.PROMOTIONS.VIEW,
  PROMOTIONS_CREATE: P.VENTES.PROMOTIONS.CREATE,
  PROMOTIONS_EDIT: P.VENTES.PROMOTIONS.EDIT,
  PROMOTIONS_DELETE: P.VENTES.PROMOTIONS.DELETE,
  PROFILS_VIEW: P.VENTES.PROFILS.VIEW,
  PROFILS_CREATE: P.VENTES.PROFILS.CREATE,
  PROFILS_EDIT: P.VENTES.PROFILS.EDIT,
  PROFILS_DELETE: P.VENTES.PROFILS.DELETE,
  TAXES_VIEW: P.VENTES.TAXES.VIEW,
  TAXES_CREATE: P.VENTES.TAXES.CREATE,
  TAXES_EDIT: P.VENTES.TAXES.EDIT,
  TAXES_DELETE: P.VENTES.TAXES.DELETE,
  ORGANISMES_VIEW: P.VENTES.ORGANISMES.VIEW,
  ORGANISMES_CREATE: P.VENTES.ORGANISMES.CREATE,
  ORGANISMES_EDIT: P.VENTES.ORGANISMES.EDIT,
  ORGANISMES_DELETE: P.VENTES.ORGANISMES.DELETE,
} as const;

export const CODE_REGEX = /^[A-Z][A-Z0-9_]*$/;
export const CODE_MESSAGE =
  "Doit commencer par une lettre majuscule, suivie de majuscules, chiffres ou underscores";
export const REMISE_MIN = 0;
export const REMISE_MAX = 100;
export const STATUT_OPTIONS = ["Actif", "Inactif"] as const;
export const PROMO_TYPE_OPTIONS = ["pourcentage"] as const;
export const ECHELON_TYPE_OPTIONS = ["remise", "rabais"] as const;
